import React from "react";
import { aux } from "theme";
import * as overlays from "components/Popups/Overlays";
import { withOverlay } from "../wrappers/withOverlay";
import { CrossIcon } from "../Svg";

const Overlay = ({ overlayContext }) => {
  const { componentProps, ...props } = overlayContext;
  const allProps = { ...componentProps, ...props };
  const { componentType, isOpen, closeOverlay } = props;
  const Component = overlays[componentType];
  return isOpen ? (
    <div
      className="fixed left-0 w-full"
      style={{
        height: `calc(100vh - ${aux.headerHeight}px - ${aux.mobile.navbarHeight}px)`,
        top: aux.headerHeight,
        zIndex: 100
      }}
    >
      <div className="relative h-full">
        <button
          type="button"
          className="fixed mt-6 cursor-pointer z-10 right-0 mr-3"
          // style={{ right: 10, top: 10 }}
          onClick={closeOverlay}
        >
          <CrossIcon />
        </button>
        <Component {...allProps} />
      </div>
    </div>
  ) : null;
};

Overlay.defaultProps = {
  className: "",
  style: {}
};

export default withOverlay(Overlay);
